<template>
  <sidebar
    :addTitle="$t('MRMR.ProfessionalOrder.AddNew')"
    :editTitle="$t('MRMR.ProfessionalOrder.Edit')"
    :isSidebarActive="isSidebarActive"
    :data="data"
    @onNewData="newData"
    @onEditData="editData"
    @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        <vs-row class="mb-3">
          <vs-col  vs-w="12">
            <ValidationProvider :name="$t('MRMR.ProfessionalOrder.Name')" rules="required" v-slot="{ errors }">
              <validated-input
                :label="$t('MRMR.ProfessionalOrder.Name')"
                v-model="name"
                name="name"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
      </div>
    </ValidationObserver>
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>
import {
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "@/app/shared/components";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar
  },
  data() {
    return {
      id: 0,
      name: ""
    };
  },
  computed : {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const { id, name } = JSON.parse(JSON.stringify(this.data));
      this.id = id;
      this.name = name;
 
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
      this.id = 0;
      this.name = '';
    },
    submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            id : this.id, 
            name: this.name
          };

          if (this.id !== null && this.id > 0) {
            this.$store.dispatch("mrmr/updateProfessionalOrder", obj).then((response) => {
              this.$emit("onProfessionalOrderUpdated", response.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("mrmr/addProfessionalOrder", obj).then((response) => {
              this.$emit("onProfessionalOrderInserted", response.data);
              this.id = response.data.id;
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>
